import * as types from '@colonist/types'

// Never change the order
// Never delete without migration
// Ok to add values to the end
// Ok to rename

// Need to update adminGiveAchievement command after reaching 100 achievements
export enum AchievementType {
    August2019TournamentWinner = 0,
    August2019TournamentFinalist = 1,
    August2019TournamentSemifinalist = 2,
    August2019TournamentParticipant = 3,
    November2019TournamentWinner = 4,
    November2019TournamentFinalist = 5,
    November2019TournamentSemifinalist = 6,
    November2019TournamentParticipant = 7,
    January2020TournamentWinner = 8,
    January2020TournamentFinalist = 9,
    January2020TournamentSemifinalist = 10,
    January2020TournamentParticipant = 11,
    February2020TournamentWinner = 12,
    February2020TournamentFinalist = 13,
    February2020TournamentSemifinalist = 14,
    February2020TournamentParticipant = 15,
    April2020TournamentWinner = 16,
    April2020TournamentFinalist = 17,
    April2020TournamentSemifinalist = 18,
    April2020TournamentParticipant = 19,
}

/**
 * @deprecated Import AccessLevel from @colonist/types
 */
export import AccessLevel = types.AccessLevel

export enum UserRelationshipType {
    FriendRequest = 0,
    Friend = 1,
}

export enum AnalyticEventType {
    StartedGame = 0, // March 11, 2022. Jeff: Unused enum. Removed in https://github.com/colonistio/katan/pull/6406#pullrequestreview-904893246
    ClickedStore = 1,
    FinishedGame = 2,
    QuitMatchmakingQueue = 3,
    StoreClickedPurchaseItem = 4,
    LobbyClickedStoreAd = 5,
    MatchmakingFoundGame = 6,
    MatchmakingDisconnected = 7,
    MatchmakingForceMatched = 8,
    MatchmakingRequestRate = 9,
    FirstSignIn = 10,
    LobbyCTADefault = 11,
    LobbyCTAType1 = 12,
    LobbyCTAType2 = 13,
    LobbyCTAType3 = 14,

    // ABTest Subscription (v129)
    ABTestSubscriptionDefault = 15,

    ABTestSubscription5D1v1 = 16,
    ABTestSubscription5D4p = 17,
    ABTestSubscription5DAds = 18,
    ABTestSubscription5DAICoaching = 19,
    ABTestSubscription5DBlock = 20,
    ABTestSubscription5DCheat = 21,
    ABTestSubscription5DExport = 22,
    ABTestSubscription5DHistory = 23,
    ABTestSubscription5DLink = 24,
    ABTestSubscription5DLiveStats = 25,
    ABTestSubscription5DPause = 26,
    ABTestSubscription5DReplay = 27,
    ABTestSubscription5DRewards = 28,
    ABTestSubscription5DTrolls = 29,

    ABTestSubscription1D1v1 = 30,
    ABTestSubscription1D4p = 31,
    ABTestSubscription1DAds = 32,
    ABTestSubscription1DAICoaching = 33,
    ABTestSubscription1DBlock = 34,
    ABTestSubscription1DCheat = 35,
    ABTestSubscription1DExport = 36,
    ABTestSubscription1DHistory = 37,
    ABTestSubscription1DLink = 38,
    ABTestSubscription1DLiveStats = 39,
    ABTestSubscription1DPause = 40,
    ABTestSubscription1DReplay = 41,
    ABTestSubscription1DRewards = 42,
    ABTestSubscription1DTrolls = 43,

    // ABTest Subscription Price 1 (v130)
    ABTestSubscriptionPriceDefault = 44,
    ABTestSubsAll5D = 45,
    ABTestSubsAll9D = 46,
    ABTestSubsAll19D = 47,
    ABTestSubsAll29D = 48,

    ABTestSubsExpansion5D = 49,
    ABTestSubsExpansion9D = 50,
    ABTestSubsExpansion19D = 51,
    ABTestSubsExpansion29D = 52,

    ABTestSubsMap5D = 53,
    ABTestSubsMap9D = 54,
    ABTestSubsMap19D = 55,
    ABTestSubsMap29D = 56,

    ABTestSubsRanked5D = 57,
    ABTestSubsRanked9D = 58,
    ABTestSubsRanked19D = 59,
    ABTestSubsRanked29D = 60,

    ABTestSubsExpMap5D = 61,
    ABTestSubsExpMap9D = 62,
    ABTestSubsExpMap19D = 63,
    ABTestSubsExpMap29D = 64,

    // ABTest Subscription Price 2 (v131)
    ABTestSubs2Ranked4D = 65,
    ABTestSubs2Ranked8D = 66,
    ABTestSubs2Ranked14D = 67,
    ABTestSubs2Ranked19D = 68,

    ABTestSubs2All8D = 69,
    ABTestSubs2All14D = 70,
    ABTestSubs2All19D = 71,
    ABTestSubs2All24D = 72,

    // ABTest CTA2 (v132)
    ABTestCTADefault = 73,
    ABTestCTA1 = 74,
    ABTestCTA2 = 75,
    ABTestCTA3 = 76,
    ABTestCTA4 = 77,
    ABTestCTA5 = 78,
    ABTestCTA6 = 79,
    ABTestCTA7 = 80,
    ABTestCTA8 = 81,
    ABTestCTA9 = 82,
    ABTestCTA10 = 83,
    ABTestCTA11 = 84,

    // ABtest Subscription Price 3 (v133)
    ABTestSubs3Ranked699 = 86,
    ABTestSubs3Ranked899 = 87,
    ABTestSubs3Ranked1099 = 88,
    ABTestSubs3Ranked1299 = 89,
    ABTestSubs3Ranked1499 = 90,

    ABTestSubs3All1899 = 91,
    ABTestSubs3All2099 = 92,
    ABTestSubs3All2299 = 93,
    ABTestSubs3All2499 = 94,
    ABTestSubs3All2699 = 95,

    MatchmakingSkillGapMax = 96,
    MatchmakingSkillStandardDeviation = 97,
    MatchmakingPercentileGapMax = 98,
    MatchmakingPercentileStandardDeviation = 99,

    ABTestDefaultYearly = 100,
    ABTestDefaultMonthly = 101,

    ABTestCancelPurchaseActive = 102,
    ABTestCancelPurcahseInactive = 103,

    ABTestCheckoutBackButtonActive = 104,
    ABTestCheckoutBackButtonInactive = 105,

    ABTestClickAnalytics = 106,

    PageVisit = 107,

    ABTestImpressionAnalytics = 108,

    RankedDemotion = 109,
    RankedPromotion = 110,

    StartPreRollCalled = 111,
    VideoAdsCalled = 112,
    VideoAdsComplete = 113,
    VideoAdsError = 114,
    VideoAdsHidden = 115,
    H5AdsCalled = 116,
    H5AdsViewed = 117,
    H5AdsDismissed = 118,
    H5AdsError = 119,

    MatchmakingEnteredQueue = 120,
    MatchmakingFailedToWatchVideoAd = 121,
    MatchmakingServerRequestToStartGame = 122,
    MatchmakingServerFailedToStartGame = 123,

    DiscordActivityAuthError = 124,

    ChannelListLength = 125,
    UserChannelLength = 126,

    PremiumRoomEnabled = 127,
    PremiumRoomStarted = 128,

    // Stopped tracking events 129 - 133 on v248
    GameCreateTrade = 129,
    GamePassedTurn = 130,
    GameClickedDice = 131,
    GameBuiltCity = 132,
    InitialPipCount = 133,

    CopiedRoomLink = 134,
    GameBoughtDevCard = 135,

    // Stopped trancking event 136 on v248
    GameUsedHoverActions = 136,

    ClickedChangeMobileOrientation = 137,
    InteractedWithLandingPageHowToPlaySection = 138,

    LostWebGLContext = 139,
    VLIAdFailedToLoad = 140,
    UserAccessedLog = 141,
    UserAccessedChat = 142,

    UserNavigationPlay = 143,
    UserNavigationLobby = 144,
    UserSceneChange = 145,
    UserCopiedLink = 146,

    BeginnerPlacedRoad = 147,
    BeginnerPlacedSettlement = 148,

    BeginnerModeFirstRoadUnlocked = 149,
    BeginnerModeDiceUnlocked = 151,
    BeginnerModeSecondRoadUnlocked = 152,
    BeginnerModeTradeUnlocked = 153,
    BeginnerModeSettlementUnlocked = 154,
    BeginnerModeCityUnlocked = 155,
    BeginnerModeSecondCityUnlocked = 156,
    BeginnerModeClickedNextLevel = 157,

    BeginnerModeLevel1 = 158,
    BeginnerModeLevel2 = 159,

    MobileGameStarted = 160,
    MobileGameUserInteractedWithFeedView = 161,
    MobileGameUserPausedGame = 162,
    MobileGameUserEnteredSettings = 163,
    MobileGameUserCompletedGame = 164,
    MobileGameUserOpenedRulebook = 165,
    MobileGameUserLeftGame = 166,

    BeginnerModeSuggestedOnMultiplayerClick = 167,
    BeginnerModeStartedThroughSuggestion = 168,

    EndGameReturnToMapButton = 191,
    Replay = 180, // rename EndGameViewReplayButton
    EndGameShareButton = 169,

    VideoAdsEmpty = 170,
    VideoAdsBlocked = 171,
    VideoAdsNeverLoaded = 172,
    VideoAdsSkipped = 173,

    ClickedJoinColonistDiscordCTA = 174,
    ClickedOfficialDiscordServerLink = 175,

    AcceptedJoinOurDiscordPopup = 176,
    EndGameShareTitle = 177,
    MobileUserSwitchedApp = 178,

    /**
     * @deprecated Use GameState analysis instead to track suspicious messages
     */
    UserSentSuspiciousMessage = 179,

    ReplayClickedViewFromProfileGameHistory = 185,
    ReplayClickedChangePerspective = 186,
    ReplayClickedCreateShareableLink = 187,
    ReplayClickedOpenStats = 192,
    ReplayControlsFirstInteraction = 193,

    JoinedRoom = 181,

    BeginnerModeClickedRetry = 182,

    RespondToFriendRoomInvite = 183,
    CreateFriendRoomInvite = 184,
    ClickedInviteFriendButton = 201,

    ProfilePageVisitSection = 188,
    ABTestVeteranAgreedOnDiscount = 189,
    ABTestVeteranRejectedDiscount = 190,

    DiscordPopupKeepPlayingOnWeb = 194,

    /**
     * @deprecated Not used anymore. Do not delete enum.
     */
    EndGameReplayAPIDelay = 195,
    GiftingFlowAnalytic = 196,
    SelectedGiftTier = 197,
    CatanMasterpieceAdClicks = 198, // Not used anymore. Do not delete enum.

    SocialMediaFooterLink = 199, // Not used

    SocketStatsAfterGame = 200,

    ABTestRoomLifecycleData = 202, // Not used anymore. Do not delete enum.

    ReferralAnalytics = 203,

    ABTestBeginnerMode = 204, // not used

    ReactivationAnalytics = 205,

    Friends = 206,

    /**
     * @deprecated Not used anymore. Do not delete enum.
     */
    RateChatExperience = 207,

    EndGameWasDiceUnfair = 208,

    SocketSequenceError = 209,

    MatchmakingPlayButtonClicked = 210, // not used
    MatchmakingPlayButtonTimeToFirstClick = 211, // not used
    MatchmakingUITimeToFirstQueueStart = 212,
    MatchmakingUIPageView = 213, // not used

    NotificationAnalytics = 214,
}

export enum AnalyticEventCategory {
    Game = 0,
    Store = 1,
    Matchmaking = 2,
    Lobby = 3,
    MatchmakingUnrankedClassic4P = 4,
    MatchmakingUnrankedClassic1v1 = 5,
    MatchmakingUnrankedClassicFreeMapRotation = 6, // Jan 30, 2022. Jeff: Removed because it was not popular. Do not delete enum.
    MainFunnel = 7,
    LobbyCTA = 8,
    ABTestSubscription = 9,
    ABTestSubscriptionPrice = 10,
    MatchmakingRankedClassic1v1 = 11,
    ABTestSubscriptionPrice2 = 12,
    ABTestCTA = 13,
    MatchmakingRankedClassic4P = 14,
    ABTestSubscriptionPrice3 = 16,
    ABTestDefaultYearly = 17,
    AdblockActivity = 18,
    ABTestCancelPurchase = 19,
    ABTestCheckoutBackButton = 20,
    ABTestClickAnalytics = 21,
    PageVisit = 22,
    ABTestImpressionAnalytics = 23,
    Ranked = 24,
    MatchmakingRankedCitiesAndKnights4P = 25,
    AdsPerformance = 26,
    AuthError = 27,
    Channel = 28,
    PremiumRoom = 29,
    WebGL = 30,
    MobileAnalytics = 31,
    Virality = 32,
    DiscordServer = 33,
    /**
     * @deprecated Not used anymore. Do not delete enum.
     */
    Chat = 34,
    Room = 35,
    Replay = 36,
    Profile = 37,
    DiscordConvertToWeb = 38,
    GiftMembershipOverlay = 39,
    ABTestNoTrollsOption = 40, // Not used anymore. Do not delete enum.
    Socket = 41,
    ABTestHighKarmaName = 42, // Not used anymore. Do not delete enum.
    Footer = 43,
    ABTestPushNotificationsPopup = 44,
    ShareActivityLink = 45,
    ABTestBeginnerMode = 46, // not used
    ABTestReferralProgram = 47, // Not used anymore. Do not delete enum.
    ABTestDiscordMainCTA = 48, // Not used anymore. Do not delete enum.
    BotShareActivityLink = 49,
    UserActionAgainstDiscordBot = 50,
    BotShareActivityLinkSent = 51,
    ABTestRedeemFreeAvatar = 52,
    ABTestShareActivityLinkText = 53, // Not used anymore. Do not delete enum.
    ABTestShareGameResults = 54, // Not used anymore. Do not delete enum.
    ABTestBotEndGameRankedCTA = 55, // not used
    ABTestPushReferrersToInviteMorePlayers = 56, // Not used anymore. Do not delete enum.
    MatchmakingUnrankedShuffle = 57,
    NotificationPanel = 58,
}

// DO NOT CHANGE THE ORDER OF THESE ENUMS
export enum AnalyticEventValue {
    AdblockPopupDisableAction = 1,
    AdblockPopupBecomeMemberAction = 2,
    AdblockPopupContinueAction = 3,
    InGameRemoveAdButtonLeft = 4,
    InGameRemoveAdButtonRight = 5,
    PopupMembershipIncentiveSubscription = 6,
    PopupMembershipIncentiveAvatars = 7, // not used
    PopupMembershipIncentiveMaps = 8, // not used
    PopupMembershipIncentiveAllItems = 9, // not used
    PopupMembershipIncentiveSubscriptionRoom = 10, // not used
    PopupMembershipIncentiveAvatarsRoom = 11, // not used
    PopupMembershipIncentiveMapsRoom = 12, // not used
    PopupMembershipIncentiveAllItemsRoom = 13, // not used
    PopupMembershipIncentiveExpansions = 14, // not used
    PopupMembershipIncentiveExpansionsRoom = 15, // not used
    PopupMembershipIncentiveEndgame = 16,
    ItemBoxMembershipEndgame = 18,
    StoreMembershipPlusMonthly = 19,
    StoreMembershipPremiumMonthly = 20,
    StoreMembershipEliteMonthly = 21,
    StoreMembershipPlusYearly = 22,
    StoreMembershipPremiumYearly = 23,
    StoreMembershipEliteYearly = 24,
    PopupMembershipIncentiveVisitStoreMonthly = 25, // not used
    PopupMembershipIncentiveVisitStoreYearly = 26, // not used
    PopupMembershipIncentiveVisitCheckoutYearly = 27, // not used
    PopupMembershipIncentiveVisitCheckoutMonthly = 28, // not used
    LobbyAdViewMemberships = 29,
    LobbyAdViewLeaderboards = 30,
    ABTestImplementGifLeaderboards = 31, // not used
    ABTestImplementGifMemberships = 32, // not used
    LobbyAdViewCatanCommunityCashTournament = 33, // not used
    LobbyAdViewSignIn = 34,
    LobbyAdDownloadMobile = 35,
    LobbyAdDiscordLogin = 36,
    PopupMembershipIncentiveFullScreen = 37,
    LobbyAdHire = 38,
    RoomKarmaFilterIcon = 39, // not used
    RoomBecomeAMemberButton = 40,
    RoomPremiumItemPopupBecomeAMemberButton = 41,
    RoomPremiumItemInfoMessageBecomeAMemberText = 42,
    StoreMembershipHoliday2023AllAccessPass = 43,
    PopupMatchmakingHolidaySale = 44, // not used
    RoomHolidaySale = 45, // not used
    LobbyAdFreeColor = 46,
    LobbyAdPlayCitiesAndKnights = 47,
    LobbyAdPlay1v1 = 48,
    EndGameShareButton = 49,
    InviteFriendButtonCenter = 50, // not used
    InviteFriendButtonLeft = 51,
    EndGameShareButtonHover = 52, // not used
    EndGameShareCopyButton = 53,
    EndGameShareDownloadButton = 54,
    EndGameShareDiscordButton = 55,
    EndGameReplayEndgameButton = 56, // not used
    MainPageRankedSubscribeCTA = 57,
    HeaderCoinPlusButton = 58,
    PopupMembershipIncentiveDiscordGeneral = 59,
    PopupMembershipIncentivesRankedCitiesAndKnights = 60,
    LeaderboardYoutubeSubscribe = 61, // not used
    InviteFriendButtonLeftAnimated = 62, // not used
    StartedBeginnerModeGame = 63, // not used
    Started1v1EasyBotGame = 64, // not used
    TShirtSurvey = 65, // not used
    RoomAddFriendAction = 66,
    LobbyAdRewardsProgram = 67,
    HomepageRankedInfoIcon = 68,
    MatchmakingPopupRankedCitiesAndKnightsSubscribeCTA = 69,
    LandingPageBecomeAMemberButton = 70,
    MobileLandingPageBecomeAMemberBanner = 71, // not used
    MobileProfilePageBecomeAMemberBanner = 72, // not used
    MobileLeaderboardPageBannerQualifier = 73, // not used
    LobbyAdChampionship25 = 74, // not used
    PopupMembershipIncentivesShuffleQueue = 75,
    LobbyAdShuffle = 76,
    MobileLeaderboardPageBannerShuffle = 77,
    MobileLandingPageShuffleBanner = 78,
    MobileProfilePageShuffleBanner = 79,
    NotificationPanelShuffleClickPlayNow = 80,
}

// DO NOT CHANGE THE ORDER OF THESE ENUMS
export enum ABTestImpressionAnalytic {
    AdblockPopupFormal = 1,
    AdblockPopupSupportive = 2,
    AdblockPopupHumorous = 3,
    AdblockPopupDramatic = 4,
    AdblockPopupTypeHard = 5,
    AdblockPopupTypeSoft = 6,
    ABTestShowLeaderboardPointBleedPopup = 7, // AB Test complete. Report: https://github.com/colonistio/katan/issues/8472
}

export enum LoginProviderEnum {
    Google = 1,
    Discord = 2,
    Apple = 3,
}

export enum AuditEventTypeEnum {
    UserLoginDeleted = 1,
    UserBanned = 2,
    UserUnbanned = 3,
    UserChangedRegion = 4,
    UserMuted = 5,
    UserUnmuted = 6,
    UserLoginMigrated = 7,
    GiftedCoin = 8,
    DeletedItem = 9,
    GiftedItem = 10,
    CanceledMembership = 11,
    RetrievedEmail = 12,
}

export enum FeedbackFormLocationEnum {
    EndGame = 1,
    Homepage = 2,
    QuitGame = 3,
    BeginnerModeEnd = 4, // Stopped using this enum. Read the report https://github.com/colonistio/katan/issues/17469
}

export enum JoinRoomMethod {
    ClickedCreateRoom = 1,
    ClickedLobbyRoom = 2,
    EnteredRoomLink = 3,
}

export enum ReplayAccessMethod {
    EndGame = 0,
    DirectLink = 1,
    ShareableLink = 2,
}

export enum GiftMembershipMethod {
    Store = 0,
    PlayerProfile = 1,
    ProfileFriendsTab = 2,
    InGame = 3,
    LobbyAd = 4,
    Room = 5,
    GifterAvatar = 6,
    InGameAd = 7,
}

export enum GiftingFlowAnalytics {
    SuccessfulPageCompletion = 0,
    SuccessfulCheckoutClick = 1,
}

export enum ReferralTypeEnum {
    RoomInvitation = 0,
    ShareActivityReturnToHomeAfterGameEnd = 1, // not used
    RoomInvitationInviteFriendsButtonAnimated = 2, // not used
    RoomInvitationMainCTAInverted = 3, // not used
    ShareActivityReferralProgramStore = 4,
    ShareActivityReferralProgramReturnToHomeAfterGameEndPopup = 5,
    RoomInvitationUsingShareActivityLink = 6,
}

export enum ReactivationTypeEnum {
    BotDirectMessage24HoursAfterLastActivityLaunch = 0,
    BotDirectMessage1WeekAfterLastActivityLaunch = 1,
    BotDirectMessage1MonthAfterLastActivityLaunch = 2,
    BotDirectMessage3MonthsAfterLastActivityLaunch = 3,
    BotDirectMessage6MonthsAfterLastActivityLaunch = 4,
    BotDirectMessage1YearAfterLastActivityLaunch = 5,
    BotDirectMessage2YearsAfterLastActivityLaunch = 6,
    ABTestStart = 7,
    ABTestNow = 8,
    ABTest2D = 9,
    ABTest4D = 10,
    ABTest7D = 11,
    ABTest15D = 12,
    ABTestPushReferrersToInviteMorePlayers = 13, // Not used anymore. Do not delete enum.
}

export enum ShareActivityLinkAnalytics {
    ReturnToHomeAfterGameEndPopupTriggered = 0, // not used
    ReturnToHomeAfterGameEndSuccessfullyShared = 1, // not used
    ReturnToHomeAfterGameEndPrePopupTriggered = 2,
    ReferralProgramStorePopupTriggeredLevel1 = 3,
    ReferralProgramStoreSuccessfullySharedLevel1 = 4,
    ReferralProgramStorePopupTriggeredLevel2 = 5,
    ReferralProgramStoreSuccessfullySharedLevel2 = 6,
    ReferralProgramStorePopupTriggeredLevel3 = 7,
    ReferralProgramStoreSuccessfullySharedLevel3 = 8,
    ReferralProgramStorePopupTriggeredLevel4 = 9,
    ReferralProgramStoreSuccessfullySharedLevel4 = 10,
    ReturnToHomeAfterGameEndReferralProgramPrePopupTriggered = 11,
    ReturnToHomeAfterGameEndReferralProgramPopupTriggered = 12,
    ReturnToHomeAfterGameEndReferralProgramSuccessfullyShared = 13,
    RoomInvitationUsingShareActivityLinkPopupTriggered = 14,
    RoomInvitationUsingShareActivityLinkSuccessfullyShared = 15,
    ABTestReactivateUserBaseReferralProgramPrePopupTriggered = 16,
    ABTestReactivateUserBaseReferralProgramPopupTriggered = 17,
    ABTestReactivateUserBaseReferralProgramSuccessfullyShared = 18,
    ReferralProgramStorePopupTriggeredLevel5 = 19,
    ReferralProgramStoreSuccessfullySharedLevel5 = 20,
    ABTestPushReferrersToInviteMorePlayersGroupAPopupTriggered = 21, // Not used anymore. Do not delete enum.
    ABTestPushReferrersToInviteMorePlayersGroupASuccessfullyShared = 22, // Not used anymore. Do not delete enum.
    ABTestPushReferrersToInviteMorePlayersGroupBPrePopupTriggered = 23, // Not used anymore. Do not delete enum.
    ABTestPushReferrersToInviteMorePlayersGroupBPopupTriggered = 24, // Not used anymore. Do not delete enum.
    ABTestPushReferrersToInviteMorePlayersGroupBSuccessfullyShared = 25, // Not used anymore. Do not delete enum.
    ABTestPushReferrersToInviteMorePlayersGroupCPrePopupTriggered = 26, // Not used anymore. Do not delete enum.
    ABTestPushReferrersToInviteMorePlayersGroupCPopupTriggered = 27, // Not used anymore. Do not delete enum.
    ABTestPushReferrersToInviteMorePlayersGroupCSuccessfullyShared = 28, // Not used anymore. Do not delete enum.
    PushReferrersToInviteMorePlayersPopupTriggered = 29,
    PushReferrersToInviteMorePlayersSuccessfullyShared = 30,
}

export enum BotShareActivityLinkAnalytics {
    BotDirectMessage24HoursAfterLastActivityLaunch = 0,
    BotDirectMessage1WeekAfterLastActivityLaunch = 1,
    BotDirectMessage1MonthAfterLastActivityLaunch = 2,
    BotDirectMessage3MonthsAfterLastActivityLaunch = 3,
    BotDirectMessage6MonthsAfterLastActivityLaunch = 4,
    BotDirectMessage1YearAfterLastActivityLaunch = 5,
    BotDirectMessage2YearsAfterLastActivityLaunch = 6,
    ABTestGroupAStart = 7,
    ABTestGroupANow = 8,
    ABTestGroupA2D = 9,
    ABTestGroupA4D = 10,
    ABTestGroupA7D = 11,
    ABTestGroupA15D = 12,
    ABTestGroupBStart = 13,
    ABTestGroupBNow = 14,
    ABTestGroupB2D = 15,
    ABTestGroupB4D = 16,
    ABTestGroupB7D = 17,
    ABTestGroupB15D = 18,
    ABTestGroupCStart = 19,
    ABTestGroupCNow = 20,
    ABTestGroupC2D = 21,
    ABTestGroupC4D = 22,
    ABTestGroupC7D = 23,
    ABTestGroupC15D = 24,
}

// FOUND HERE: https://discord.com/developers/docs/developer-tools/embedded-app-sdk#channeltypesobject
export enum DiscordChannelTypeEnum {
    Unhandled = -1,
    Dm = 1,
    GroupDm = 3,
    GuildText = 0,
    GuildVoice = 2,
    GuildCategory = 4,
    GuildAnnouncement = 5,
    GuildStore = 6,
    AnnouncementThread = 10,
    PublicThread = 11,
    PrivateThread = 12,
    GuildStageVoice = 13,
    GuildDirectory = 14,
    GuildForum = 15,
}

export enum ReactivationMessageTypeEnum {
    D1 = 0,
    W1 = 1,
    M1 = 2,
    M3 = 3,
    M6 = 4,
    Y1 = 5,
    Y2 = 6,
    ABTestStart = 7,
    ABTestNow = 8,
    ABTest2D = 9,
    ABTest4D = 10,
    ABTest7D = 11,
    ABTest15D = 12,
}

export enum UserActionAgainstDiscordBotAnalytics {
    BlockedAllDms = 0,
    BlockedOurBot = 1,
}

export enum RedeemFreeAvatarAnalytics {
    ABTestRedeemFreeAvatarPopupTriggered = 0,
    ABTestRedeemFreeAvatarButtonClicked = 1,
}
